(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/payment.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/payment.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (svs) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogPayment = function (_svs$components$dialo) {
    _inherits(DialogPayment, _svs$components$dialo);

    var _super = _createSuper(DialogPayment);

    function DialogPayment() {
      _classCallCheck(this, DialogPayment);

      return _super.apply(this, arguments);
    }

    _createClass(DialogPayment, [{
      key: "getContent",
      value: function getContent() {
        if (this.options.price && this.options.product) {
          if (this.options.isTicket) {
            this.options.title = "Vill du betala en ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0kr?");
          } else if (this.options.isVoucher) {
            this.options.title = "Vill du ge bort en ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0kr?");
          } else if (this.options.isBag) {
            this.options.title = "Vill du betala ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0kr?");
          } else {
            this.options.title = "Vill du betala ett spel p\xE5 ".concat(this.options.product, "\xA0f\xF6r\xA0").concat(svs.utils.format.Currency(this.options.price), "\xA0kr?");
          }
        }

        return new this.options._ContentClass(this.options);
      }
    }]);

    return DialogPayment;
  }(svs.components.dialog.Confirm);

  svs.components.dialog.Payment = DialogPayment;
})(svs);
 })(window);